import { createSlice } from "@reduxjs/toolkit";

const notificationSlice = createSlice({
  name: "notification",
  initialState: {
    visible: false,
    message: "",
    description: "",
    type: null,
  },
  reducers: {
    showNotification: (state, action) => {
      state.visible = true;
      state.message = action.payload.message;
      state.description = action.payload.description;
    },
    hideNotification: (state) => {
      state.visible = false;
      state.message = "";
      state.description = "";
      state.type = null;
    },
  },
});

export const { showNotification, hideNotification } = notificationSlice.actions;
export default notificationSlice.reducer;
